import React, { FC, useState, useEffect, useRef } from 'react'
import _ from "lodash"

import keyService, * as chord from "data/key"

import { CloseIcon } from 'images/icons/general'

import { Button_s, Colors, Svg_s } from 'styles/app-styles'
import { Modal_s, ModalContent_s, ModalTitle_s, MultipartTitle_s, PromptRow_s } from './modal-styles'
import { StyledSelect, LabelSpan, SelectRow } from "./modal-styles"
import ConfirmationAutomation from "components/modal/confirmation-automation"

interface IConfirmationModal {
  closeOnly: boolean,
  confirmOnly: boolean,
  confirmText: string,
  cancelText?: string,
  message: string,
  cancelFunc: Function,
  confirmFunc: Function,
  show: boolean,
  toggleShow: Function,
  height?: number,
  width?: number,
  contentHeight?: number,
  title?: string | Array<any>,
  scrollY?: boolean,
  tertiary?: boolean,
  tertiaryFunc?: Function,
  tertiaryText?: string,
  select?: boolean
  selectOptions?: string[]
  selectLabel?: string
}

const AUTOMATION_CLASS = "automated"

const ConfirmationModal: FC<IConfirmationModal> = (props) => {
  const selectRef = useRef(null)

  const message = props.message?.includes('<br>') ? <ul>{props.message.split('<br>').map(s => <li>{s}</li>)}</ul> : props.message
  if(!props.show) return null
  else return (
    <Modal_s {..._.omit(props, 'title')} height={props.height || 350} width={props.width || 700}>
      <div>
        <ModalTitle_s>
          {_.isArray(props.title) ? <MultipartTitle_s>{_.map(props.title, item => <div>{item}</div>)}</MultipartTitle_s> : props.title}
          <a onClick={() => props.toggleShow(false)}><Svg_s src={CloseIcon} /></a>
        </ModalTitle_s>
        <ModalContent_s
          scrollY={props.scrollY}
          style={{height: props.contentHeight ? `${props.contentHeight}px` : "268px", backgroundColor: "white"}}>
          {message}
          {props.message &&
            <div>
              <br/>
            </div>
          }
          { props.children }
        </ModalContent_s>
        <PromptRow_s>
          {!props.confirmOnly &&
            <Button_s className={AUTOMATION_CLASS} onClick={() => props.cancelFunc()}>{props.cancelText || "Cancel"}</Button_s>
          }
          {!props.closeOnly && !props.confirmOnly &&
            <Button_s className={AUTOMATION_CLASS} onClick={() => props.confirmFunc()} danger={true}>{props.confirmText}</Button_s>
          }
          {props.confirmOnly &&
            <Button_s className={AUTOMATION_CLASS} onClick={() => props.confirmFunc()} primary={true}>{props.confirmText}</Button_s>
          }
          {props.select && !_.isEmpty(props.selectOptions) &&
            <SelectRow>
              <LabelSpan>Replace with:</LabelSpan>
              <StyledSelect ref={selectRef}>
                {_.map(props.selectOptions, ([val, text], ix) => <option key={ix} value={val}>{text}</option>)}
              </StyledSelect>
            </SelectRow>
          }
          {props.tertiary &&
            <Button_s className={AUTOMATION_CLASS} onClick={() => props.tertiaryFunc ? props.tertiaryFunc(selectRef) : null} primary={true}>{props.tertiaryText}</Button_s>
          }
        </PromptRow_s>
      </div>
      <ConfirmationAutomation cancel={props.cancelFunc}/>
    </Modal_s>
  )
}

export default ConfirmationModal
